/**
 * Project panel
 * Nav.js
 * Created by stefensuhat on 2018-11-29 09:32
 */

import { Drawer, Icon, List, ListItem, ListItemText, ListSubheader, useMediaQuery, useTheme } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'clsx';
import { routeList } from 'global/routes';
import logo from 'images/logo-white.svg';
import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { red } from 'utils/theme/colorsDark';

const propTypes = {};
const defaultProps = {};


const styles = makeStyles(({ spacing, width, palette, ...theme }) => ({
    divider: {
        margin: spacing(1, 0),
        backgroundColor: 'rgba(255,255,255, 0.1)',
    },
    heading: {
        marginLeft: spacing(1),
        letterSpacing: 1,
    },
    subheader: {
        ...theme.typography.body2,
        fontWeight: 600,
        margin: spacing(2, 0),
        letterSpacing: 1,
        color: 'white',
        textTransform: 'uppercase',
    },
    item: {
        padding: 0,
    },
    itemActiveItem: {
        backgroundColor: 'rgba(233, 30, 99, 0.08)',
        fontWeight: 600,
        borderTopRightRadius: 50,
        borderBottomRightRadius: 50,
    },
    logo: {
        margin: spacing(2),
        background: `url(${logo}) no-repeat`,
        backgroundSize: 'contain',
        width: 150,
        minHeight: 50,
    },
    drawer: {
        flexShrink: 0,
        width: width.drawerLeft,
    },
    drawerPaper: {
        background: palette.background.default,
        paddingRight: spacing(2),
        width: width.drawerLeft,
    },
    drawerOpen: {
        width: width.drawerLeft,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: 0,
        [theme.breakpoints.up('sm')]: {
            width: 0,
        },
    },
    toolbar: theme.mixins.toolbar,
    icon: {
        background: 'transparent',
        // border: `1px solid ${palette.divider}`,
        // borderRadius: 100,
        color: red,
        width: spacing(5),
        height: spacing(5),
    },
}));


const mapStateToProps = ({ nav }) => ({
    open: nav.openLeft,
    openRight: nav.openRight,
});


const reduxConnector = connect(mapStateToProps, null);

function Nav(props) {
    const currentPath = `/${window.location.pathname.split('/')[1]}`;
    const classes = styles();
    const history = useHistory();
    const theme = useTheme();
    const { open } = props;
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const { nav: { toggleNav } } = useDispatch();


    function renderListItem(title, path, icon) {
        return (
            <ListItem
                button
                disableGutters
                component="div"
                key={path}
                onClick={() => {
                    if (fullScreen) toggleNav(!open);

                    return history.push(path);
                }}
                className={cx(currentPath === path && classes.itemActiveItem, classes.item)}
            >
                <ListItemIcon>
                    <Avatar className={classes.icon}><Icon fontSize="small">{icon}</Icon></Avatar>
                </ListItemIcon>

                <ListItemText
                    primary={title}
                    primaryTypographyProps={{
                        variant: 'body2',
                        style: {
                            color: currentPath === path ? red : 'white',
                            fontWeight: currentPath === path ? 600 : 400,
                        },
                    }}
                />
            </ListItem>
        );
    }

    return (
        <Drawer
            open={open}
            onClose={() => toggleNav(!open)}
            variant={fullScreen ? 'temporary' : 'permanent'}
            PaperProps={{ elevation: 0 }}
            className={cx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}
            classes={{
                paper: cx(classes.drawerPaper, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                }),
            }}
        >
            <div className={classes.logo} />

            {routeList.map((arr) => {
                if (arr.hideNav) {
                    return <div key={arr.id} />;
                }

                if (arr.children.length === 0) {
                    return (
                        <List disablePadding component="nav" key={arr.id} className={classes.parent}>
                            {renderListItem(arr.id, arr.route.path, arr.icon)}
                            <Divider className={classes.divider} />

                        </List>
                    );
                }

                return (
                    <List
                        disablePadding
                        key={arr.id}
                        component="nav"
                        className={classes.parent}
                        subheader={(
                            <ListSubheader disableSticky component="div" className={classes.subheader}>
                                {arr.id}
                            </ListSubheader>
                        )}
                    >
                        {arr.children.map(({ title, path, showOnNav, icon }) => {
                            if (showOnNav) {
                                return renderListItem(title, path, icon);
                            }
                            return <></>;
                        })}

                        <Divider component="hr" className={classes.divider} />
                    </List>
                );
            })}
        </Drawer>
    );
}

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;


export default reduxConnector(Nav);
